import React from 'react';
import Component from './Component';
import BaseInput from './NumberBase';
import classNames from 'classnames'
import Glyphicon from './Glyphicon';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

class Number extends React.Component {

	static filterDelay  = true;
	static rules = BaseInput.rules;

	getError() {
		return this.props.error && this.props.error[0];
	}

	renderInputGroup(children) {
		let addonBefore = this.props.addonBefore ? (
			<span className="input-group-addon" key="addonBefore">
        		{this.props.addonBefore}
      		</span>
		) : null;

		let addonAfter = this.props.addonAfter ? (
			<span className="input-group-addon" key="addonAfter">
      		  {this.props.addonAfter}
      		</span>
		) : null;

		let buttonBefore = this.props.buttonBefore ? (
			<span className="input-group-btn">
        		{this.props.buttonBefore}
      		</span>
		) : null;

		let buttonAfter = this.props.buttonAfter ? (
			<span className="input-group-btn">
        		{this.props.buttonAfter}
      		</span>
		) : null;

		let inputGroupClassName;
		switch (this.props.bsSize) {
			case 'small':
				inputGroupClassName = 'input-group-sm';
				break;
			case 'large':
				inputGroupClassName = 'input-group-lg';
				break;
			default:
		}

		const tooltip = this.props.help ? <Tooltip id={this.props.help}>{this.props.help}</Tooltip> : null;

		return addonBefore || addonAfter || buttonBefore || buttonAfter ? (
			<div style={{width: this.props.width}} className={classNames(inputGroupClassName, 'input-group')} key="input-group">
				{addonBefore}
				{buttonBefore}
				{children}
				{addonAfter}
				{buttonAfter}
			</div>
		) : children;
	}

	renderIcon() {
		if (this.props.hasFeedback) {
			if (this.props.feedbackIcon) {
				return React.cloneElement(this.props.feedbackIcon, {formControlFeedback: true});
			}

			switch (this.props.bsStyle) {
				case 'success':
					return <Glyphicon formControlFeedback glyph="ok" key="icon"/>;
				case 'warning':
					return <Glyphicon formControlFeedback glyph="warning-sign" key="icon"/>;
				case 'error':
					return <Glyphicon formControlFeedback glyph="remove" key="icon"/>;
				default:
					return <span className="form-control-feedback" key="icon"/>;
			}
		} else {
			return null;
		}
	}

	renderWrapper(children) {

		const classes = {
			'has-error': this.getError(),
			'nomessage-error': this.props.showErrorMessage === false
		};

		return <span className={classNames(classes, this.props.wrapperClassName)} key="wrapper">
				{children}
			</span>
	}

	renderLabel(children) {
		let classes = {
			'control-label': false
		};
		classes[this.props.labelClassName] = this.props.labelClassName;

		return this.props.label ? (
			<label htmlFor={this.props.id} className={classNames(classes)} key="label">
				{children}
				{this.props.label}
			</label>
		) : children;
	}

	renderInput() {
		const className = 'form-control';
		return <BaseInput {...this.props} className={classNames(this.props.className, className)} key="input"/>;
	}

	renderError() {
		const error = this.getError();
		return this.props.showErrorMessage !== false && error ? (
			<span className="error-block" key="error">{error}</span>
		) : null;
	}

	renderChildren() {
		return [
			//this.renderLabel(),
			this.renderWrapper([
				this.renderInputGroup(
					this.renderInput()
				),
				this.renderIcon(),
				this.renderError()
			])
		];
	}

	render() {
		let children = this.renderChildren();
		return <span>{children}</span>;
	}
}

Number.propTypes = {
	type: React.PropTypes.string,
	label: React.PropTypes.node,
	help: React.PropTypes.node,
	addonBefore: React.PropTypes.node,
	addonAfter: React.PropTypes.node,
	buttonBefore: React.PropTypes.node,
	buttonAfter: React.PropTypes.node,
	bsSize: React.PropTypes.oneOf(['small', 'medium', 'large']),
	bsStyle: React.PropTypes.oneOf(['success', 'warning', 'error']),
	hasFeedback: React.PropTypes.bool,
	feedbackIcon: React.PropTypes.node,
	id: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.number
	]),
	groupClassName: React.PropTypes.string,
	wrapperClassName: React.PropTypes.string,
	labelClassName: React.PropTypes.string,
	disabled: React.PropTypes.bool,
	value: React.PropTypes.any
};

Number.defaultProps = {
	type: 'number',
	disabled: false,
	hasFeedback: false
};

export default Number;


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/Number.js